import React from 'react';
import { Book } from '../data/bookContent';
import { Button } from './ui/Button';
import { ChevronRightIcon, HomeIcon } from 'lucide-react';
interface TableOfContentsProps {
  book: Book;
  onSelectChapter: (id: number) => void;
  onBack: () => void;
}
export function TableOfContents({
  book,
  onSelectChapter,
  onBack
}: TableOfContentsProps) {
  return <div className="min-h-screen bg-stone-50 text-stone-900" data-id="element-244">
      <header className="sticky top-0 z-10 bg-stone-50/95 backdrop-blur border-b border-stone-200 p-4 shadow-sm" data-id="element-245">
        <div className="max-w-3xl mx-auto flex items-center justify-between" data-id="element-246">
          <Button variant="ghost" onClick={onBack} aria-label="Volver a la portada" data-id="element-247">
            <HomeIcon className="h-6 w-6 mr-2" data-id="element-248" />
            <span className="hidden sm:inline" data-id="element-249">Portada</span>
          </Button>
          <h2 className="text-xl font-serif font-bold text-stone-800" data-id="element-250">
            Índice
          </h2>
          <div className="w-10" data-id="element-251" /> {/* Spacer for balance */}
        </div>
      </header>

      <main className="max-w-3xl mx-auto p-6 pb-20" data-id="element-252">
        <div className="space-y-4" data-id="element-253">
          {book.chapters.map((chapter, index) => <button key={chapter.id} onClick={() => onSelectChapter(index)} className="w-full text-left bg-white p-6 rounded-2xl shadow-sm border border-stone-100 hover:border-amber-300 hover:shadow-md transition-all group focus:outline-none focus:ring-4 focus:ring-amber-500/30" data-id="element-254">
              <div className="flex items-start justify-between" data-id="element-255">
                <div className="flex-1 pr-4" data-id="element-256">
                  <span className="text-amber-700 font-bold text-sm tracking-wider uppercase mb-1 block" data-id="element-257">
                    Capítulo {chapter.id}
                  </span>
                  <h3 className="text-2xl font-serif font-bold text-stone-900 group-hover:text-amber-800 transition-colors" data-id="element-258">
                    {chapter.title}
                  </h3>
                  <p className="text-stone-600 mt-2 text-lg leading-relaxed" data-id="element-259">
                    {chapter.objective}
                  </p>
                </div>
                <div className="self-center bg-stone-100 p-2 rounded-full group-hover:bg-amber-100 transition-colors" data-id="element-260">
                  <ChevronRightIcon className="h-6 w-6 text-stone-400 group-hover:text-amber-700" data-id="element-261" />
                </div>
              </div>
            </button>)}
        </div>
      </main>
    </div>;
}